<div class="specific-expenditure">
  <div class="row middle-xs between-xs">
    <div class="col-no-gutter">
      <h4 class="specific-expenditure__title">{{label}}</h4>
    </div>
    <ng-container *ngIf="!readonly">
      <div class="col-sm-3 col-no-gutter">
        <mfp-button
          class="specific-expenditure__remove"
          color="secondary"
          [fill]="removeFill"
          [size]="removeSize"
          [icon]="removeIcon"
          [iconPosition]="removeIconPosition"
          [label]="removeLabel"
          (click)="remove()"
        ></mfp-button>
      </div>
    </ng-container>

  </div>
  <div [formGroup]="form">
    <div class="row">
      <div class="col-xs-24 col-sm-9 col-gutter-lr">
        <mfp-input-currency
          [name]="amountName"
          [formControlName]="amountName"
          type="text"
          view="agent"
          [label]="amountLabel"
          [currencyOptions]="currencyOptions"
          [success]="isFieldValid(form, amountName)"
          [error]="isFieldInvalid(form, amountName)"
          [helper]="getFieldError(form, amountName)"
          [readonly]="readonly"
          [required]="required"
        ></mfp-input-currency>
      </div>
      <div class="col-xs-24 col-xs--no-margin col-sm-6 col-gutter-lr">
        <mfp-select
          [name]="typeName"
          [formControlName]="typeName"
          view="agent"
          [label]="typeLabel"
          [placeholder]="typePlaceholder"
          [options]="typeOptions"
          [color]="typeColor"
          [success]="isFieldValid(form, typeName)"
          [error]="isFieldInvalid(form, typeName)"
          [helper]="getFieldError(form, typeName) | translate"
          [readonly]="readonly"
          [required]="required"
        ></mfp-select>
      </div>
    </div>
  </div>
</div>
